import Array from './Array';
import CollapsibleFieldset from './CollapsibleFieldset';
import Columns from './Columns';
import Fieldset from './Fieldset';
import Tabs from './Tabs';

export default {
	Array,
	CollapsibleFieldset,
	Columns,
	Fieldset,
	Tabs,
};
